import React, { FC } from 'react'
import { graphql, useFragment } from 'react-relay'
import { Element } from '../Element'
import { Link } from '../Link'
import { LinkText } from '../Text'
import { Stack } from '../Stack'
import { UserPrimaryPhoto } from '@components/User/UserPrimaryPhoto'
import { UserBackgroundPhoto } from '@components/User/UserBackgroundPhoto'

import { UserShortCard_user$key } from './__generated__/UserShortCard_user.graphql'

export const UserShortCard: FC<{
  user: UserShortCard_user$key
  expand?: boolean
}> = ({ user, expand = false }) => {
  const data = useFragment(
    graphql`
      fragment UserShortCard_user on User {
        slugId
        firstName
        lastName

        backgroundPhoto {
          id
        }

        ...UserPrimaryPhoto_user
        ...UserBackgroundPhoto_user
      }
    `,
    user
  )

  return (
    <Stack expand={expand}>
      <Element component='ActorCard' tokens={expand ? { flex: 1 } : undefined}>
        <Stack gap={4} expand={expand}>
          <Stack>
            <Element component='ActorCardPhotos'>
              <UserBackgroundPhoto user={data} />

              <Element tokens={{ marginTop: -10 }}>
                <UserPrimaryPhoto size={20} user={data} variant='inCard' />
              </Element>
            </Element>
          </Stack>

          <Stack expand={expand}>
            <Element
              component='ActorCardInfo'
              tokens={expand ? { flex: 1 } : undefined}
            >
              <Stack gap={4} expand={expand}>
                <Stack gap={2} expand={expand}>
                  <Link to={`/${data.slugId}`}>
                    <LinkText
                      numberOfLines={1}
                      size={6}
                      variant='userBlockHeading'
                    >
                      {data.firstName} {data.lastName}
                    </LinkText>
                  </Link>
                </Stack>
              </Stack>
            </Element>
          </Stack>
        </Stack>
      </Element>
    </Stack>
  )
}
